import React, { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import PageLayout from '../../components/common/PageLayout';
import { ProductsFeeds } from '../../components/pages/ProductsFeeds';
import { TAB_CHANNELS, TAB_INGESTION_TO_CYMBIO } from '../../constants/productsFeeds';

export default function ProductsFeedsPageContainer() {
  const [tab, setTab] = useState(TAB_INGESTION_TO_CYMBIO);

  return (
    <PageLayout>
      <h1 style={{ marginBottom: '1em' }}>Product Feeds</h1>

      <Tabs
        activeKey={tab}
        defaultActiveKey={TAB_INGESTION_TO_CYMBIO}
        className="tabs"
        onSelect={setTab}
        style={{ marginBottom: 32 }}
      >
        <Tab eventKey={TAB_INGESTION_TO_CYMBIO} title={TAB_INGESTION_TO_CYMBIO} />
        <Tab disabled eventKey={TAB_CHANNELS} title={TAB_CHANNELS} />
      </Tabs>

      {tab === TAB_INGESTION_TO_CYMBIO && <ProductsFeeds />}

      {tab === TAB_CHANNELS && <div>Channels</div>}
    </PageLayout>
  );
}
